import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, TemplateRef, Input } from '@angular/core';

import { InputAtomSharedComponent } from '../../atoms/input/input.component';

export const EXPIRY_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(() => InputTooltipSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-tooltip',
    templateUrl: './input-tooltip.component.html',
    styleUrls: ['./input-tooltip.component.scss'],
    providers: [
        EXPIRY_CUSTOM_INPUT_ACCESSOR
    ]
})

export class InputTooltipSharedComponent extends InputAtomSharedComponent {
    // tslint:disable-next-line: no-input-rename
    @Input('value') _value = '';
    @Input() inputStyle = 'primary';
    @Input() inputType = 'text';
    @Input() tooltip = '';
    @Input() tooltipTemplate: TemplateRef<any>;
    @Input() icon = '';
    @Input() iconTooltip = 'custom-question-circle';
    @Input() placement = 'top';
    @Input() tooltipClass = 'sg-tooltip--primary';

    focused = false;
}
